import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '../ui';

/**
 * Back button — navigates one step back in history (navigate(-1)).
 * If there's no in-app history to pop (deep link / hard refresh, where
 * location.key === 'default'), it falls back to /home instead of leaving the app.
 */
export function BackButton({ className }: { className?: string }) {
  const navigate = useNavigate();
  const location = useLocation();

  const onBack = () => {
    if (location.key && location.key !== 'default') navigate(-1);
    else navigate('/home');
  };

  return (
    <button
      type="button"
      onClick={onBack}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-[10px] border border-line bg-surface px-3 py-1.5 text-sm font-semibold text-content shadow-soft transition-colors hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 dark:hover:bg-brand-900/20',
        className,
      )}
    >
      <ArrowLeft className="size-4" /> Back
    </button>
  );
}
